import React from 'react';
import { Mail } from 'lucide-react';
import { footerData } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import logoWhite from '../assets/logo/fieldstech-logo-white.png';

const Footer = () => {
  const { ref: footerRef, isVisible } = useScrollAnimation();

  return (
    <footer className="bg-black border-t border-white/10">
      <div ref={footerRef} className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8 sm:py-10 lg:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-10">
          {/* Column 1 - Company Info */}
          <div className={`scroll-animate ${isVisible ? 'in-view' : ''}`}>
            <div className="mb-4">
              <img
                src={logoWhite}
                alt="Fieldstech"
                className="h-8 sm:h-9 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-[#F0F0F0] leading-relaxed">
              {footerData.company.description}
            </p>
          </div>

          {/* Column 2 - Services */}
          <div className={`scroll-animate delay-200 ${isVisible ? 'in-view' : ''}`}>
            <h4 className="text-base font-semibold text-white mb-3">
              {footerData.services.title}
            </h4>
            <ul className="space-y-2">
              {footerData.services.links.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={link.action}
                    className="text-sm text-[#F0F0F0] hover:text-[#10B981] transition-colors duration-200 text-left"
                  >
                    {link.text}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div className={`scroll-animate delay-400 ${isVisible ? 'in-view' : ''}`}>
            <h4 className="text-base font-semibold text-white mb-3">
              {footerData.contact.title}
            </h4>
            <div className="space-y-2">
              <a
                href={`mailto:${footerData.contact.email}`}
                className="flex items-center gap-2 text-sm text-[#F0F0F0] hover:text-[#10B981] transition-colors duration-200 group"
              >
                <Mail className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" />
                <span>{footerData.contact.email}</span>
              </a>
            </div>
          </div>

          {/* Column 4 - Legal */}
          <div className={`scroll-animate delay-600 ${isVisible ? 'in-view' : ''}`}>
            <h4 className="text-base font-semibold text-white mb-3">
              {footerData.legal.title}
            </h4>
            <ul className="space-y-2">
              {footerData.legal.links.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={link.action}
                    className="text-sm text-[#F0F0F0] hover:text-[#10B981] transition-colors duration-200 text-left"
                  >
                    {link.text}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-6"></div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-sm text-gray-400">
            {footerData.legal.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
